import React from "react";
import { Card, CardContent } from "src/components/ui/Card";
import { Textarea } from "src/components/ui/TextArea";

interface SessionNotesCardProps {
  notes: string;
  onNotesChange: (notes: string) => void;
}

export const SessionNotesCard: React.FC<SessionNotesCardProps> = ({
  notes,
  onNotesChange,
}) => {
  return (
    <Card className="border border-slate-200 rounded-xl shadow-xs overflow-hidden bg-white">
      <div className="bg-[#faf9fe] px-6 py-4 border-b border-slate-200">
        <div className="text-xs font-mono text-purple-700 font-medium">STEP 4 • DIAGNOSTIC INSTRUCTIONS</div>
        <h2 className="text-base font-bold text-slate-900">Session Objectives & Operational Notes</h2>
      </div>
      <CardContent className="p-6">
        <Textarea
          id="notes"
          placeholder="Special instructions, curriculum objectives, or topics to cover during session..."
          value={notes}
          onChange={(e) => onNotesChange(e.target.value)}
          className="min-h-[100px] text-xs font-normal border-slate-300"
        />
      </CardContent>
    </Card>
  );
};

